import { render, staticRenderFns } from "./PowerBIViewCreate.vue?vue&type=template&id=55af86f5"
import script from "./PowerBIViewCreate.vue?vue&type=script&lang=js"
export * from "./PowerBIViewCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports